import { useContext } from "react";
import CacheContext from "contexts/CacheContext";

const useRestoreCacheId = () => useContext(CacheContext).restoreCacheId;

export default useRestoreCacheId;
